export const passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
export const passwordCacheKey = 'password-cache';
